import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=f1e64192&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=ts"
export * from "./Staff.vue?vue&type=script&lang=ts"
import style0 from "./Staff.vue?vue&type=style&index=0&id=f1e64192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e64192",
  null
  
)

export default component.exports